import DispensaryObservation from './ui/DispensaryObservation'

export default DispensaryObservation